import script from "./GeneralLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeneralLayout.vue?vue&type=script&lang=ts&setup=true"

import "./GeneralLayout.vue?vue&type=style&index=0&id=8b7a871e&lang=scss"

const __exports__ = script;

export default __exports__